// 给根节点设置 id=root 即可

$(function(){
    $('#root').css('zoom','normal')
    let scale = document.body.clientWidth / 1080;
    $('#root').css('zoom',scale)

    window.addEventListener('resize',function(){
        var timer;
        return function(){
            if(timer) clearTimeout(timer);
            timer = setTimeout(function(){
                $('#root').css('zoom','normal')
                let scale = document.body.clientWidth / 1080;
                $('#root').css('zoom',scale)
            },100)
        }
    }())
})


function lazyLoadImages() {
  const images = document.querySelectorAll('.lazy-load'); // 获取所有需要懒加载的图片
  const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0
  };

  const lazyLoadObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
          if (entry.isIntersecting) { // 当图片进入视口时
              const image = entry.target;
              const dataSrc = image.getAttribute('data-src');
              image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
              lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
      });
  }, config);

  images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
  });
}


document.addEventListener('DOMContentLoaded', function(){
  lazyLoadImages()

  var links = document.querySelectorAll('a[href^="#shopping"]');
        links.forEach(function(link) {
            link.addEventListener("click", function(event) {
                event.preventDefault(); // 阻止默认的跳转行为
                const targetElement = document.getElementById('shopping'); // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop ;
                window.scroll({
                    top: offsetTop * ($('div#root').css('zoom')) - 132 * ($('div#root').css('zoom')),
                    behavior: 'smooth' // 使用 smooth 实现平滑滚动
                });
            });
        });
});